<template>
  <div class="classNumView flex">
    <!-- 课次列表部分开始 -->
    <div class="classTimesList">
      <!-- 输入课次搜索框 -->
      <div class="courseSearch-content">
        <div class="courseSearch-box flex align spaceBetween">
          <input v-model="courseName" @keyup.enter="courseSearch(courseName)" class="courseSearch" type="text"
            placeholder="输入课次名称" />
          <img @click="courseSearch(courseName)" class="searchIcon pointer"
            src="../../assets/resourceManagement/searchIcon.png" />
        </div>
      </div>
      <!-- 课次列表标题 -->
      <div class="classTimesList-title-box flex align">
        <div class="classTimesList-block"></div>
        <div class="classTimesList-title">课次列表</div>
      </div>
      <!-- 课次列表 -->
      <div class="classList-box">
        <div @click="singleClass(item)" :class="currentClassesId == item.id ? 'allClasses' : 'classList'"
          v-for="(item, index) in allListClasses" :key="index">
          <div class="flex align">
            <div class="classList-circle"></div>
            <div class="classList-num">课次{{ index + 1 }}</div>
            <div class="classList-name">{{ item.name }}</div>
          </div>
          <div class="flex align">
            <div class="integral-num">{{ item.finishNum }}/{{ studentList.length }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 课次列表部分结束 -->
    <!-- 学生列表部分开始 -->
    <div class="studentList-content">
      <!-- 班级选择器 -->
      <div class="classSelector flex align justify">
        <div class="selector-txt">班级</div>
        <el-cascader v-model="classValue" @change="classHandleChange" :options="classOptions"></el-cascader>
      </div>
      <!-- 学生列表 -->
      <div class="studentList-box">
        <div v-for="(item, index) in studentList" :key="index"
          :class="currentStudentId == item.id ? 'unSelectStudents' : 'unSelectStudents'">
          <div class="flex align">
            <img class="rankImg" v-if="index == 0" src="@/assets/first.png" />
            <img class="rankImg" v-if="index == 1" src="@/assets/second.png" />
            <img class="rankImg" v-if="index == 2" src="@/assets/third.png" />
            <div class="student-ranking" v-if="index != 0 && index != 1 && index != 2">{{ index + 1 }}</div>
            <img class="head-sculpture" :src="item.icon != '' ? item.icon : require('@/assets/head.png')" />
            <div class="flex column spaceBetween" style="margin-left: 10px">
              <div class="studentTxt">{{ item.name }}</div>
              <div class="studentTxt">{{ item.account }}</div>
            </div>
          </div>
          <div class="flex align">
            <div class="integral-num">{{ item.coursePoints }}</div>
            <div class="integral-txt">积分</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 学生列表部分结束 -->
    <!-- 课程数据部分开始 -->
    <div class="data-box">
      <!-- 数据标题 -->
      <div class="classTimesList-title-box flex align">
        <div class="classTimesList-block"></div>
        <div class="classTimesList-title">{{ dataType == "课程" ? this.$store.state.courseDetails.name + "-课程数据" :
            currentClassesName + "-课次数据" }}</div>
      </div>
      <!-- 课次数据 -->
      <div class="classNumberData-box flex column">
        <div class="flex spaceBetween" style="padding-bottom: 5px; box-sizing: border-box">
          <div class="echarts-box">
            <myChart :preData="preData[0]"></myChart>
            <div class="flex justify" style="margin-top: 10px">
              <div class="echartsPie-key">资源观看</div>
              <div class="echartsPie-value">{{ dataEcharts[0].watched }}/{{ assetsNum }}</div>
            </div>
            <div class="flex justify" style="margin-top: 10px">
              <div class="echartsPie-key">观看时长</div>
              <div class="echartsPie-value">{{ dataEcharts[0].minuteSecond }}</div>
            </div>
          </div>
          <div class="echarts-box">
            <myChart :preData="preData[1]"></myChart>
            <div class="flex justify" style="margin-top: 10px">
              <div class="echartsPie-key">习题完成度</div>
              <div class="echartsPie-value">{{ dataEcharts[1].completionDegree }}/{{ examitemNum }}</div>
            </div>
            <div class="flex justify" style="margin-top: 10px">
              <div class="echartsPie-key">习题正确度</div>
              <div class="echartsPie-value">{{ dataEcharts[1].accuracy }}/{{ examitemNum }}</div>
            </div>
          </div>
          <div class="echarts-box">
            <myChart :preData="preData[2]"></myChart>
            <div class="flex justify" style="margin-top: 10px">
              <div class="echartsPie-key">作业完成度</div>
              <div class="echartsPie-value">{{ dataEcharts[2].completionDegree }}/{{ examNum }}</div>
            </div>
            <div class="flex justify" style="margin-top: 10px">
              <div class="echartsPie-key">作业正确度</div>
              <div class="echartsPie-value">{{ dataEcharts[2].accuracy }}/{{ examNum }}</div>
            </div>
          </div>
        </div>
        <!-- 教学实施部分开始 -->
        <div class="tableStyle flex column align">
          <div class="tableWidth">
            <div class="resourceList-h1Box flex align">
              <div class="resourceList-colorBlock"></div>
              <div class="resourceList-h1">教学实施</div>
            </div>
            <!-- 课前准备部分开始 -->
            <div style="margin-top: 2px">
              <div class="resourceList-h2Box flex align">
                <div class="resourceList-round"></div>
                <div class="resourceList-h2">课前准备</div>
              </div>
              <el-table :data="beforeClassList" :show-header="false" :cell-style="tableRowClassName"
                :row-style="{ height: '30px' }" fit>
                <el-table-column show-overflow-tooltip align="center" prop="name"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="types"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="created"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="score1"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center">
                  <template slot-scope="scope">
                    <div class="completionStatus">{{ scope.row.completedNum }}/{{ studentList.length }}</div>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip align="center">
                  <template slot-scope="scope">
                    <img @click="viewResources(scope)" class="btnView pointer"
                      src="../../assets/studentStatisticsIcon/iocnView.png" />
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 课前准备部分结束 -->
            <!-- 课堂教学部分开始 -->
            <div>
              <div class="resourceList-h2Box flex align">
                <div class="resourceList-round"></div>
                <div class="resourceList-h2">课堂教学</div>
              </div>
              <el-table :data="middleClassList" :show-header="false" :cell-style="tableRowClassName"
                :row-style="{ height: '30px' }" fit>
                <el-table-column show-overflow-tooltip align="center" prop="name"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="types"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="created"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="score1"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center">
                  <template slot-scope="scope">
                    <div class="completionStatus">{{ scope.row.completedNum }}/{{ studentList.length }}</div>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip align="center">
                  <template slot-scope="scope">
                    <img @click="viewResources(scope)" class="btnView pointer"
                      src="../../assets/studentStatisticsIcon/iocnView.png" />
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 课堂教学部分结束 -->
            <!-- 课后巩固部分开始 -->
            <div>
              <div class="resourceList-h2Box flex align">
                <div class="resourceList-round"></div>
                <div class="resourceList-h2">课后巩固</div>
              </div>
              <el-table :data="afterClassList" :show-header="false" :cell-style="tableRowClassName"
                :row-style="{ height: '30px' }" fit>
                <el-table-column show-overflow-tooltip align="center" prop="name"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="types"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="created"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="score1"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center">
                  <template slot-scope="scope">
                    <div class="completionStatus">{{ scope.row.completedNum }}/{{ studentList.length }}</div>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip align="center">
                  <template slot-scope="scope">
                    <img @click="viewResources(scope)" class="btnView pointer"
                      src="../../assets/studentStatisticsIcon/iocnView.png" />
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 课后巩固部分结束 -->
          </div>
        </div>
        <!-- 教学实施部分结束 -->
      </div>
    </div>
    <!-- 课程数据部分结束 -->
    <!-- 资源查看弹窗部分开始 -->
    <div v-show="showPopupResourceView" class="popup-resourceView flex align justify">
      <div class="resourceView-content">
        <img @click="showPopupResourceView = false" class="btnClose pointer" src="../../assets/btnClose.png" />
        <div class="popup-title flex justify">{{ dataResourceView.typesOf }}详情</div>
        <!-- 资源 -->
        <div v-if="dataResourceView.typesOf == '资源'" class="resourceView-rolling">
          <div class="resourcesDetails-frame flex align justify">
            <el-image v-if="dataResourceView.types == '图片资源'" class="resourcesDetails-img" fit="cover"
              :src="dataResourceView.content[0]" :preview-src-list="dataResourceView.content"> </el-image>
            <video v-else-if="dataResourceView.types == '视频资源'" class="resourcesDetails-frame1" controls
              :src="dataResourceView.content[0]"></video>
            <img v-else @click="viewRes" class="resourcesDetails-typeImg pointer"
              src="@/assets/documentResourcesIcon.png" />
          </div>
          <div class="flex">
            <div class="dataResourceView-key">资源名称：</div>
            <div class="dataResourceView-value">{{ dataResourceView.name }}</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">资源类型：</div>
            <div class="dataResourceView-value">{{ dataResourceView.types }}</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">资源分值：</div>
            <div class="dataResourceView-value">{{ dataResourceView.score1 }}</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">得分设置：</div>
            <div class="dataResourceView-value">观看{{ dataResourceView.percent }}%以上即可得分</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">查看次数：</div>
            <div class="dataResourceView-value">{{ dataResourceView.studentViewNum }}次</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">已查看人数：</div>
            <div class="dataResourceView-value">{{ dataResourceView.studentViewNum }}/{{ studentList.length }}人</div>
          </div>
          <div class="dataResourceView-value" style="line-height: 20px">{{ dataResourceView?.studentCompletedStr }}
          </div>
          <div class="flex">
            <div class="dataResourceView-key">未查看人数：</div>
            <div class="dataResourceView-value">{{ studentList.length - dataResourceView.studentViewNum }}/{{
            studentList.length }}人</div>
          </div>
          <div class="dataResourceView-value" style="line-height: 20px">{{ dataResourceView.studentIncomplete }}</div>
        </div>
        <!-- 习题 -->
        <div v-if="dataResourceView.typesOf == '习题'" class="resourceView-rolling">
          <div class="flex spaceBetween">
            <div class="flex align">
              <div class="questionType-block"></div>
              <div class="questionType">{{ dataResourceView.types }}</div>
            </div>
            <div class="question-score">{{ dataResourceView.score }}分</div>
          </div>
          <div class="question-stem">{{ dataResourceView.name }}</div>
          <div v-for="(item, index) in dataResourceView.options" :key="index">
            <div v-if="dataResourceView.types != '简答题'"
              :class="dataResourceView.answer.includes(index) ? 'question-option flex align' : 'question-option1 flex align'">
              {{ optionOrder[index] }}.{{ item }}
              <img v-if="dataResourceView.answer.includes(index)" class="iconIsItCorrect"
                :src="require(`@/assets/correctIcon.png`)" />
            </div>
          </div>
          <div v-if="dataResourceView.types == '简答题'" class="answers-box">{{ dataResourceView.studentAnswer }}</div>
          <div v-if="dataResourceView.types != '简答题'" class="question-txt">答案：{{ dataResourceView.translatedAnswer }}
          </div>
          <div class="question-txt">解析：{{ dataResourceView.comment }}</div>
          <div class="flex">
            <div class="dataResourceView-key">正确人数：</div>
            <div class="dataResourceView-value">{{ dataResourceView.studentViewNum }}/{{ studentList.length }}人</div>
          </div>
          <div class="dataResourceView-value" style="line-height: 20px">{{ dataResourceView.studentCompletedStr }}</div>
          <div class="flex">
            <div class="dataResourceView-key">错误人数：</div>
            <div class="dataResourceView-value">{{ studentList.length - dataResourceView.studentViewNum }}/{{
            studentList.length }}人</div>
          </div>
          <div class="dataResourceView-value" style="line-height: 20px">{{ dataResourceView.studentIncomplete }}</div>
        </div>
        <!-- 作业 -->
        <div v-if="dataResourceView.typesOf == '作业'" class="resourceView-rolling">
          <div class="flex">
            <div class="dataResourceView-key">作业名称：</div>
            <div class="dataResourceView-value">{{ dataResourceView.name }}</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">组卷方式：</div>
            <div class="dataResourceView-value">{{ dataResourceView.types }}</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">作业题数：</div>
            <div class="dataResourceView-value">{{ dataResourceView.num_item }}</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">作业满分：</div>
            <div class="dataResourceView-value">{{ dataResourceView.score1 }}</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">平均得分：</div>
            <div class="dataResourceView-value">{{ Math.floor(dataResourceView.averageScore) }}分</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">全部完成人数：</div>
            <div class="dataResourceView-value">{{ dataResourceView.completedNum }}/{{ studentList.length }}人</div>
          </div>
          <div class="dataResourceView-value" style="line-height: 20px">{{ dataResourceView.completedNameList.join("、")
            }}
          </div>
          <div class="flex">
            <div class="dataResourceView-key">部分完成人数：</div>
            <div class="dataResourceView-value">{{ dataResourceView.partCompletedNameList.length }}/{{
            studentList.length
          }}人</div>
          </div>
          <div class="dataResourceView-value" style="line-height: 20px">{{
              dataResourceView.partCompletedNameList.join("、")
            }}</div>
          <div class="flex">
            <div class="dataResourceView-key">未完成人数：</div>
            <div class="dataResourceView-value">{{ studentList.length - dataResourceView.partCompletedNameList.length -
            dataResourceView.completedNameList.length }}/{{ studentList.length }}人</div>
          </div>
          <div class="dataResourceView-value" style="line-height: 20px">{{ dataResourceView.incompleteNameList }}</div>
        </div>
      </div>
    </div>
    <!-- 资源查看弹窗部分结束 -->
  </div>
</template>

<script>
// 接口
import { courseLearningRecords, obtainTeacherTeachingClass } from "@/api";
// 组件
import echartsPie from "@/components/echarts_pie";
// 组件
import myChart from "@/components/echarts_pie/echats.vue";
export default {
  data() {
    return {
      studentList: [], // 学生列表
      classOptions: [], // 班级选项
      classValue: ["2021级", 1], // 默认班级
      currentStudentId: 0, // 当前学生id
      classId: 0,
      allListClasses: [], // 课次列表
      allListClasses1: [], // 课次列表原始数据
      currentClassesId: 0, // 当前课次id
      currentClassesName: 0, // 当前课次名称
      courseName: "", // 课次搜索的课次名称
      dataType: "课程", // 课程课次切换
      preData: [
        {
          title: "资源详情",
          show: false,
          typeList: [
            { value: 0, name: "已得分数" },
            { value: 0, name: "未得分数" },
          ],
          countLength: "",
        },
        {
          title: "习题详情",
          show: false,
          typeList: [
            { value: 0, name: "已得分数" },
            { value: 0, name: "未得分数" },
          ],
          countLength: "",
        },
        {
          title: "作业详情",
          show: false,
          typeList: [
            { value: 0, name: "已得分数" },
            { value: 0, name: "未得分数" },
          ],
          countLength: "",
        },
      ],
      // echarts详情数据
      dataEcharts: [
        { watched: 0, notWatched: 0, minuteSecond: "00分00秒" },
        { completionDegree: 0, completionTotal: 0, accuracy: 0 },
        { completionDegree: 0, completionTotal: 0, accuracy: 0 },
      ],
      resourceList: [], // 资源列表
      beforeClassList: [], // 课前列表
      middleClassList: [], // 课中列表
      afterClassList: [], // 课后列表
      dataResourceView: {}, // 资源查看数据
      optionOrder: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      showPopupResourceView: false, // 是否展示资源查看弹窗
      assetsNum: 0, // 资源数量
      examitemNum: 0, // 试题数量
      examNum: 0, // 作业数量
    };
  },
  components: { echartsPie, myChart },
  created() {
    // 调用获取老师授课班级列表接口
    let params = { lesson_id: this.$store.state.courseDetails.id };
    obtainTeacherTeachingClass(params).then((res) => {
      let groupedData = res.data.datas.reduce((groups, item) => {
        (groups[item.grade] = groups[item.grade] || []).push(item);
        return groups;
      }, {});
      this.classValue[0] = res.data.datas[0].grade;
      this.classValue[1] = res.data.datas[0].id;
      this.classId = res.data.datas[0].id;
      for (let key in groupedData) {
        for (let j in groupedData[key]) {
          let publicRes = groupedData[key];
          publicRes[j].value = publicRes[j].id;
          publicRes[j].label = publicRes[j].name;
        }
        this.classOptions.push({
          value: key,
          label: key,
          children: groupedData[key],
        });
      }
      // 第一层按value从大到小排列
      this.classOptions.sort((a, b) => b.value.split("级")[0] - a.value.split("级")[0]);
      // 第二层的children按value从小到大排列
      this.classOptions.forEach(item => {
        if (item.children && Array.isArray(item.children)) {
          item.children.sort((a, b) => a.name.split("班")[0] - b.name.split("班")[0]);
        }
      });
      // 调用获取数据方法
      this.publicGettingDataFunc();
    });
  },
  methods: {
    // 转换成00分00秒格式
    funcTimeConversion(num) {
      let minutes = Math.floor(num / 60);
      let seconds = num % 60;
      let formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
      let formattedSeconds = seconds < 10 ? "0" + seconds : seconds;
      let result = formattedMinutes + "分" + formattedSeconds + "秒";
      return result;
    },
    // 升序、降序排序
    compare(property, desc) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        if (desc == true) {
          // 升序排列
          return value1 - value2;
        } else {
          // 降序排列
          return value2 - value1;
        }
      };
    },
    // 判断字符串最后一个字符是否为,有则删掉
    processString(str) {
      // 获取字符串最后一个字符的索引
      const lastCharIndex = str.lastIndexOf(",");
      // 如果最后一个字符是逗号，则删除它
      if (lastCharIndex === str.length - 1) {
        return str.slice(0, lastCharIndex);
      }
      // 如果最后一个字符不是逗号，则返回原字符串
      return str;
    },
    // 获取数据方法
    publicGettingDataFunc() {
      this.assetsNum = 0;
      this.examitemNum = 0;
      this.examNum = 0;
      this.dataEcharts = [
        { watched: 0, notWatched: 0, minuteSecond: "00分00秒" },
        { completionDegree: 0, completionTotal: 0, accuracy: 0 },
        { completionDegree: 0, completionTotal: 0, accuracy: 0 },
      ];
      this.preData[0].typeList[0].value = 0;
      this.preData[1].typeList[0].value = 0;
      this.preData[2].typeList[0].value = 0;
      let params = { lesson_id: this.$store.state.courseDetails.id, class_id: this.classId, types: "" };
      courseLearningRecords(params).then((res) => {
        // 获取学生表格数据
        this.studentList = res.data.ext.users.map((item) => {
          item.coursePoints = 0;
          res.data.ext.lesson_user.map(({ score, user_account, lesson_item_id }) => {
            if (item.account == user_account && this.currentClassesId == lesson_item_id) {
              // 计算单个课次课程积分
              item.coursePoints += score;
            }
          });
          return { id: item.id, name: item.name, icon: item.icon, account: item.account, coursePoints: item.coursePoints, examScore: 0 };
        });
        this.studentList.sort(this.compare("coursePoints", false)); // 排名排序
        this.currentStudentId = this.studentList[0]?.id; // 获取学生id
        // 计算课程数据echarts图表数据
        this.preData[0].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "分}";
        this.preData[1].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "分}";
        this.preData[2].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "分}";
        let assetsScore = 0; // 资源总分
        let examitemScore = 0; // 习题总分
        let examScore = 0; // 作业总分
        for (let i in res.data.datas) {
          let publicRes = res.data.datas[i];
          if (this.dataType == "课程" ? publicRes.types == "assets" : publicRes.types == "assets" && publicRes.lesson_item_id == this.currentClassesId) {
            assetsScore += publicRes.assets.score;
            this.preData[0].countLength = "{totalText|共计}" + "\n" + "{totalText|" + assetsScore + "分}";
            this.dataEcharts[0].notWatched++;
          } else if (this.dataType == "课程" ? publicRes.types == "examitem" : publicRes.types == "examitem" && publicRes.lesson_item_id == this.currentClassesId) {
            examitemScore += publicRes.exam_item.score;
            this.preData[1].countLength = "{totalText|共计}" + "\n" + "{totalText|" + examitemScore + "分}";
            this.dataEcharts[1].completionTotal++;
          } else if (this.dataType == "课程" ? publicRes.types == "exam" : publicRes.types == "exam" && publicRes.lesson_item_id == this.currentClassesId) {
            examScore += publicRes.exam.score;
            this.preData[2].countLength = "{totalText|共计}" + "\n" + "{totalText|" + examScore + "分}";
            this.dataEcharts[2].completionTotal++;
          }
        }
        // 获取当前课程课次的数据
        this.allListClasses = this.$store.state.classListRecord.map((item) => {
          item.classPoints = 0;
          for (let i in res.data.datas) {
            let publicRes = res.data.datas[i];
            if (publicRes.types == "assets") {
              publicRes.score = publicRes.assets.score;
            } else if (publicRes.types == "examitem") {
              publicRes.score = publicRes.exam_item.score;
            } else if (publicRes.types == "exam") {
              publicRes.score = publicRes.exam.score;
            }
            if (publicRes.lesson_item_id == item.id) {
              item.classPoints += publicRes.score; // 获取课次总分
            }
          }
          return { name: item.name, id: item.id, integral: 0, classPoints: item.classPoints, finishNum: 0 };
        });
        // console.log(this.allListClasses);
        this.allListClasses1 = this.allListClasses;
        let durationTime = 0; // 资源观看总时长
        for (let i in res.data.ext.lesson_user) {
          let publicRes = res.data.ext.lesson_user[i];
          for (let j in this.allListClasses) {
            if (this.allListClasses[j].id == publicRes.lesson_item_id) {
              // 计算学生课次积分
              this.allListClasses[j].integral += publicRes.score;
              if (this.dataType == "课程" ? publicRes.link_type == "assets" : publicRes.link_type == "assets" && publicRes.lesson_item_id == this.currentClassesId) {
                this.preData[0].typeList[0].value += publicRes.score;
                durationTime += publicRes.duration; // 计算资源观看时长
              } else if (this.dataType == "课程" ? publicRes.link_type == "examitem" : publicRes.link_type == "examitem" && publicRes.lesson_item_id == this.currentClassesId) {
                this.preData[1].typeList[0].value += publicRes.score;
              } else if (this.dataType == "课程" ? publicRes.link_type == "exam" : publicRes.link_type == "exam" && publicRes.lesson_item_id == this.currentClassesId) {
                this.preData[2].typeList[0].value += publicRes.score;
              }
            }
          }
        }
        // 计算未完成课次积分
        this.preData[0].typeList[1].value = assetsScore - this.preData[0].typeList[0].value;
        this.preData[1].typeList[1].value = examitemScore - this.preData[1].typeList[0].value;
        this.preData[2].typeList[1].value = examScore - this.preData[2].typeList[0].value;
        // 计算资源观看时长
        this.dataEcharts[0].minuteSecond = this.funcTimeConversion(durationTime);
        if (this.dataType == "课次") {
          // 获取课次资源数据
          let courseResources = res.data.datas.filter((item) => item.lesson_item_id == this.currentClassesId);
          // 课次答题记录
          let answerRecordList = res.data.ext.lesson_user.filter(({ lesson_item_id }) => lesson_item_id == this.currentClassesId);
          for (let i in courseResources) {
            let publicRes = courseResources[i];
            if (publicRes.types == "assets") {
              publicRes.assets.link_id = publicRes.id;
              publicRes.assets.typesOf = "资源";
              if (publicRes.assets.types == "video") {
                publicRes.assets.types = "视频资源";
              } else if (publicRes.assets.types == "audio") {
                publicRes.assets.types = "音频资源";
              } else if (publicRes.assets.types == "doc") {
                publicRes.assets.types = "文档资源";
              } else if (publicRes.assets.types == "image") {
                publicRes.assets.types = "图片资源";
              } else if (publicRes.assets.types == "web") {
                publicRes.assets.types = "资源链接";
              } else if (publicRes.assets.types == "h5") {
                publicRes.assets.types = "特殊互动";
              }
              publicRes.assets.score1 = publicRes.assets.score + "分"; // 转换分数格式
              publicRes.assets.created = publicRes.assets.created.substring(0, 10);
              this.resourceList.push(publicRes.assets);
            } else if (publicRes.types == "examitem") {
              publicRes.exam_item.link_id = publicRes.id;
              publicRes.exam_item.typesOf = "习题";
              if (publicRes.exam_item.types == "single") {
                publicRes.exam_item.types = "单选题";
              } else if (publicRes.exam_item.types == "multi") {
                publicRes.exam_item.types = "多选题";
              } else if (publicRes.exam_item.types == "truefalse") {
                publicRes.exam_item.types = "判断题";
              } else if (publicRes.exam_item.types == "answer") {
                publicRes.exam_item.types = "简答题";
              }
              publicRes.exam_item.score1 = publicRes.exam_item.score + "分"; // 转换分数格式
              publicRes.exam_item.name = publicRes.exam_item.content.replace(/<[^>]+>/g, ""); // 转换名字格式
              publicRes.exam_item.created = publicRes.exam_item.created.substring(0, 10);
              this.resourceList.push(publicRes.exam_item);
            } else if (publicRes.types == "exam") {
              publicRes.exam.link_id = publicRes.id;
              publicRes.exam.typesOf = "作业";
              if (publicRes.exam.types == "manual") {
                publicRes.exam.types = "作业-手动";
              } else if (publicRes.exam.types == "auto") {
                publicRes.exam.types = "作业-自动";
              }
              publicRes.exam.num_item = publicRes.exam.num_item + "道"; // 转换题数格式
              publicRes.exam.score1 = publicRes.exam.score + "分"; // 转换分数格式
              publicRes.exam.created = publicRes.exam.created.substring(0, 10);
              this.resourceList.push(publicRes.exam);
            }
          }
          for (let i in this.resourceList) {
            let publicRes = this.resourceList[i];
            publicRes.completed = false;
            publicRes.completedNum = 0;
            if (publicRes.typesOf == "资源") {
              this.assetsNum++;
              for (let j in answerRecordList) {
                if (publicRes.link_id == answerRecordList[j].link_resource_id) {
                  publicRes.completedNum++;
                  if (publicRes.completedNum == this.studentList.length) {
                    this.dataEcharts[0].watched++;
                    publicRes.completed = true;
                  }
                }
              }
            } else if (publicRes.typesOf == "习题") {
              this.examitemNum++;
              for (let j in answerRecordList) {
                if (publicRes.link_id == answerRecordList[j].link_resource_id) {
                  publicRes.completedNum++;
                  if (publicRes.completedNum == this.studentList.length) {
                    this.dataEcharts[1].accuracy++; // 计算习题完成
                    this.dataEcharts[1].completionDegree++; // 计算试题正确度
                    publicRes.completed = true;
                  }
                }
              }
            } else if (publicRes.typesOf == "作业") {
              publicRes.completedNameList = []; // 作业完成人名单
              publicRes.partCompletedNameList = []; // 作业部分完成人名单
              publicRes.incompleteNameList = []; // 作业未完成人名单
              publicRes.averageScore = 0; // 作业平均分
              this.examNum++; // 获取作业数量
              for (let j in answerRecordList) {
                if (answerRecordList[j].link_type == "exam" && publicRes.link_id == answerRecordList[j].link_resource_id && answerRecordList[j].link_exam_item_id) {
                  publicRes.averageScore += answerRecordList[j].score;
                  for (let z in this.studentList) {
                    if (this.studentList[z].account == answerRecordList[j].user_account) {
                      this.studentList[z].examScore += answerRecordList[j].score;
                      if (this.studentList[z].examScore == publicRes.score && this.studentList[z].examScore > 0) {
                        publicRes.completedNum++;
                        if (!publicRes.completedNameList.includes(this.studentList[z].name)) {
                          publicRes.completedNameList.push(this.studentList[z].name); // 获取完成学生名单
                        }
                      } else if (this.studentList[z].examScore != 0) {
                        if (!publicRes.partCompletedNameList.includes(this.studentList[z].name)) {
                          publicRes.partCompletedNameList.push(this.studentList[z].name); // 获取部分完成学生名单
                        }
                      }
                      publicRes.partCompletedNameList = publicRes.partCompletedNameList.filter((value) => !publicRes.completedNameList.includes(value));
                      let studentList = this.studentList.map(({ name }) => {
                        return name;
                      });
                      let studentArr = [...publicRes.completedNameList, ...publicRes.partCompletedNameList];
                      // 获取两个数组的交集
                      let intersection = studentList.filter((value) => studentArr.includes(value));
                      // 删除交集中的元素
                      publicRes.incompleteNameList = studentList.filter((value) => !intersection.includes(value)).join("、"); // 获取未完成学生名单
                    }
                  }
                  if (publicRes.completedNum == this.studentList.length) {
                    publicRes.completed = true;
                    this.dataEcharts[2].completionDegree++; // 计算作业已观看
                    this.dataEcharts[2].accuracy++; // 计算作业正确度
                  }
                }
              }
            }
            publicRes.averageScore = publicRes.averageScore / this.studentList.length; // 获取作业平均分
            if (publicRes.usage == "front") {
              this.beforeClassList.push(publicRes); // 课前准备数据获取
            } else if (publicRes.usage == "middle") {
              this.middleClassList.push(publicRes); // 课堂教学数据获取
            } else if (publicRes.usage == "back") {
              this.afterClassList.push(publicRes); // 课后巩固数据获取
            }
          }
          // console.log("课前", this.beforeClassList);
          // console.log("课中", this.middleClassList);
          // console.log("课后", this.afterClassList);
        }

        let { users, lesson_user } = res.data.ext;
        //学生信息
        let userList = {};
        for (let i = 0; i < users.length; i++) {
          userList[users[i].id] = users[i];
        }
        //每个课次的答题记录
        let recordList = lesson_user;
        recordList.forEach((item) => {
          if (!userList[item.user_id].lesson) userList[item.user_id].lesson = {};
          if (userList[item.user_id].lesson[item.lesson_item_id]) {
            userList[item.user_id].lesson[item.lesson_item_id] += item.score;
          } else {
            userList[item.user_id].lesson[item.lesson_item_id] = item.score;
          }
        });
        for (let i = 0; i < this.allListClasses.length; i++) {
          for (let key in userList) {
            if (userList[key].lesson && userList[key].lesson[this.allListClasses[i].id] == this.allListClasses[i].classPoints) {
              this.allListClasses[i].finishNum += 1;
            }
          }
        }
        console.log(this.allListClasses);
      });
    },
    // table行的 className 的回调方法
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      let cellStyle;
      if (row.completed == true) {
        cellStyle = "color:#12A13A";
      } else {
        cellStyle = "";
      }
      return cellStyle;
    },
    // 班级选择器
    classHandleChange(value) {
      this.classId = value[1];
      this.classValue[1] = value[1]; // 获取班级id
      this.resourceList = []; // 清空资源数据
      this.beforeClassList = []; // 清空课前准备数据
      this.middleClassList = []; // 清空课堂教学数据
      this.afterClassList = []; // 清空课后巩固数据
      // 调用获取数据方法
      this.publicGettingDataFunc();
    },
    // 选择学生
    selectStudents(id) {
      this.dataType = "课程";
      this.currentStudentId = id;
      this.publicGettingDataFunc();
    },
    // 课次搜索
    courseSearch(name) {
      this.allListClasses = [];
      for (let i = 0; i < this.allListClasses1.length; i++) {
        if (this.allListClasses1[i].name.indexOf(name) >= 0) {
          this.allListClasses.push(this.allListClasses1[i]);
        }
      }
    },
    // 课次选择
    singleClass(data) {
      this.dataType = "课次";
      this.currentClassesId = data.id;
      this.currentClassesName = data.name;
      this.resourceList = []; // 清空资源数据
      this.beforeClassList = []; // 清空课前准备数据
      this.middleClassList = []; // 清空课堂教学数据
      this.afterClassList = []; // 清空课后巩固数据
      this.publicGettingDataFunc();
    },
    // 查看资源
    viewResources(data) {
      this.showPopupResourceView = true;
      if (data.row.typesOf == "资源") {
        // data.row.studentViewNum = 0; // 学生查看次数
        // data.row.studentCompleted = []; // 学生完成名单
        // data.row.studentCompletedStr = ""; // 学生完成名单字符串
        // data.row.studentIncomplete = []; // 学生未完成名单
        let params = { lesson_id: this.$store.state.courseDetails.id, class_id: this.classId, types: "" };
        courseLearningRecords(params).then((res) => {
          let answerRecord = res.data.ext.lesson_user.filter(({ link_resource_id }) => link_resource_id == data.row.link_id);
          if (answerRecord.length != 0) {
            data.row.studentViewNum = answerRecord.length; // 获取学生查看次数
            data.row.studentCompleted = answerRecord.map((item) => {
              let xiu = this.studentList.filter(({ account }) => account == item.user_account);
              return xiu[0].name;
            });
            data.row.studentCompletedStr = data.row.studentCompleted.join("、"); // 学生完成名单字符串
            console.log(data.row.studentCompletedStr);
            let studentList = this.studentList.map(({ name }) => {
              return name;
            });
            // 获取两个数组的交集
            let intersection = studentList.filter((value) => data.row.studentCompleted.includes(value));
            // 删除交集中的元素
            data.row.studentIncomplete = studentList.filter((value) => !intersection.includes(value)).join("、");
          }
          this.dataResourceView = data.row; // 将整理好的数据渲染到页面
        });
      } else if (data.row.typesOf == "习题") {
        data.row.name = data.row.name.replace(/<[^>]+>/g, ""); // 格式化题目题干
        data.row.comment = data.row.comment.replace(/<[^>]+>/g, ""); // 格式化题目解析
        // data.row.studentViewNum = 0; // 学生查看次数
        // data.row.studentCompleted = []; // 学生完成名单
        // data.row.studentCompletedStr = ""; // 学生完成名单字符串
        // data.row.studentIncomplete = []; // 学生未完成名单
        let params = { lesson_id: this.$store.state.courseDetails.id, class_id: this.classId, types: "" };
        courseLearningRecords(params).then((res) => {
          let answerRecord = res.data.ext.lesson_user.filter(({ link_resource_id, score }) => link_resource_id == data.row.link_id && score != 0);
          if (answerRecord.length != 0) {
            data.row.studentViewNum = answerRecord.length;
            data.row.studentCompleted = answerRecord.map((item) => {
              let xiu = this.studentList.filter(({ account }) => account == item.user_account);
              return xiu[0].name;
            });
            data.row.studentCompletedStr = data.row.studentCompleted.join("、"); // 学生完成名单字符串
            // console.log(data.row.studentCompleted);
            let studentList = this.studentList.map(({ name }) => {
              return name;
            });
            // 获取两个数组的交集
            let intersection = studentList.filter((value) => data.row.studentCompleted.includes(value));
            // 删除交集中的元素
            data.row.studentIncomplete = studentList.filter((value) => !intersection.includes(value)).join("、");
            this.dataResourceView = data.row; // 将整理好的数据渲染到页面
          }
        });
      } else if (data.row.typesOf == "作业") {
        this.dataResourceView = data.row; // 将整理好的数据渲染到页面
      }
      console.log(data.row);
    },
    // 查看资源
    viewRes() {
      window.open(this.dataResourceView.content[0]);
    },
  },
};
</script>

<style lang="scss" scoped>
.classNumView {
  height: calc(100% - 87px);
}

.studentList-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 315px);
  overflow: scroll;
}

.student-ranking {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 40px;
  font-size: 20px;

  font-weight: 400;
  color: #349afe;
}

.selectStudents {
  display: flex;
  justify-content: space-between;
  width: 374px;
  background: #eaeaea;
  padding: 10px 20px;
  box-sizing: border-box;
  cursor: pointer;
}

.unSelectStudents {
  display: flex;
  justify-content: space-between;
  width: 374px;
  background: #ffffff;
  padding: 10px 20px;
  box-sizing: border-box;
  //   cursor: pointer;
}

// .unSelectStudents:hover {
//   background: #eaeaea;
// }
.rankImg {
  width: 46px;
  height: 40px;
}

.head-sculpture {
  margin-left: 11px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.studentTxt {
  font-size: 16px;

  font-weight: 400;
  color: #555555;
}

.integral-num {
  font-size: 30px;

  font-weight: 400;
  color: #349afe;
}

.integral-txt {
  margin-top: 9px;
  font-size: 14px;

  font-weight: 400;
  color: #555555;
}

.classTimesList {
  width: 559px;
  height: 100%;
  border-right: 1px solid #bfbfbf;
}

.courseSearch-box {
  width: 406px;
  height: 45px;
  border: 1px solid #dddddd;
  border-radius: 23px;
  padding: 0 27px;
  box-sizing: border-box;
}

.courseSearch {
  width: 300px;
  font-size: 18px;

  font-weight: 400;
  color: #999999;
  background-color: transparent;
  border: 0px;
  outline: none;
}

.classTimesList-title-box {
  margin-bottom: 2px;
  background: rgba(52, 154, 254, 0.25);
  padding: 17px 20px;
  box-sizing: border-box;
}

.classTimesList-title {
  margin-left: 20px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.classList-box {
  height: calc(100vh - 400px);
  overflow: scroll;
}

.allClasses {
  background: #eaeaea;
  padding: 16px 31px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.classList-circle {
  width: 10px;
  height: 10px;
  background: #3096fb;
  border-radius: 50%;
}

.classList-num {
  margin-left: 22px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.classList-name {
  margin-left: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.classList {
  padding: 16px 31px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.classList:hover {
  background: #eaeaea;
}

.data-box {
  width: calc(100% - 964px);
}

.courseData-box {
  height: calc(100% - 60px);
  padding: 30px 0 0 60px;
  box-sizing: border-box;
}

.searchIcon {
  width: 25px;
  height: 25px;
}

.courseSearch-content {
  padding: 20px 30px;
  box-sizing: border-box;
}

.classTimesList-block {
  width: 12px;
  height: 26px;
  background: #3096fb;
}

.echartsPie-box {
  width: 318px;
  height: 251px;
}

.echartsPie-key {
  font-size: 22px;

  font-weight: 400;
  color: #555555;
  line-height: 22px;
}

.echartsPie-value {
  margin-left: 20px;
  font-size: 22px;

  font-weight: 400;
  color: #349afe;
  line-height: 22px;
}

.classNumberData-box {
  height: calc(100% - 60px);
  padding: 16px;
  box-sizing: border-box;
}

.echarts-box {
  width: 220px;
}

.tableStyle {
  height: calc(100vh - 280px);
  box-sizing: border-box;
  overflow: scroll;
}

.tableWidth {
  width: 100%;
}

.resourceList-h1Box {
  padding-left: 20px;
  height: 60px;
  background: #cce6ff;
}

.resourceList-colorBlock {
  width: 12px;
  height: 26px;
  background: #3096fb;
}

.resourceList-h1 {
  margin-left: 20px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.resourceList-h2Box {
  padding-left: 30px;
  height: 50px;
  background: #eaeaea;
}

.resourceList-round {
  width: 10px;
  height: 10px;
  background: #3096fb;
  border-radius: 50%;
}

.resourceList-h2 {
  margin-left: 22px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 22px;
}

.btnView {
  width: 22px;
  height: 22px;
}

// 查看资源弹窗
.popup-resourceView {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 10;
}

.resourceView-content {
  position: relative;
  width: 520px;
  height: 805px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  padding: 24px 30px;
  box-sizing: border-box;
}

.popup-title {
  font-size: 26px;

  font-weight: 400;
  color: #349afe;
}

.btnClose {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 23px;
  height: 23px;
}

.questionType-block {
  width: 8px;
  height: 18px;
  background: #3096fb;
}

.questionType {
  font-size: 18px;
  font-weight: normal;
  color: #000000;
  margin-left: 12px;
}

.question-score {
  font-size: 18px;
  font-weight: normal;
  color: #1f96fa;
}

.question-txt {
  margin-top: 14px;
  font-size: 18px;
  font-weight: normal;
  color: #1f96fa;
}

.question-stem {
  margin-top: 25px;
  font-size: 18px;
  font-weight: normal;
  color: #777777;
  line-height: 18px;
}

.question-option {
  position: relative;
  margin-top: 16px;
  width: 454px;
  height: 48px;
  background: #1f96fa;
  border: 1px solid #1f96fa;
  border-radius: 10px;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: normal;
  color: #ffffff;
}

.question-option1 {
  position: relative;
  margin-top: 16px;
  width: 454px;
  height: 48px;
  background: #eeeeee;
  border: 1px solid #777777;
  border-radius: 10px;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: normal;
  color: #777777;
}

.answers-box {
  margin-top: 18px;
  width: 454px;
  height: 163px;
  border: 1px solid #777777;
  border-radius: 10px;
  padding: 16px 20px;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: normal;
  color: #777777;
  line-height: 24px;
}

.iconIsItCorrect {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 35px;
  height: 35px;
}

.resourcesDetails-frame {
  margin-top: 28px;
  width: 457px;
  height: 256px;
  background: #ffffff;
  border: 1px solid #757575;
  border-radius: 10px;
}

.resourcesDetails-frame1 {
  width: 457px;
  height: 256px;
  background: #ffffff;
  border: 1px solid #757575;
  border-radius: 10px;
}

.resourcesDetails-typeImg {
  width: 242px;
  height: 243px;
}

.resourcesDetails-detailsList {
  width: 653px;
  height: 280px;
}

.resourcesDetails-img {
  width: 457px;
  height: 256px;
  border-radius: 10px;
}

.dataResourceView-key {
  margin-top: 20px;
  font-size: 18px;

  font-weight: 400;
  color: #3096fb;
  line-height: 18px;
}

.dataResourceView-value {
  margin-top: 20px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.exam-key {
  font-size: 18px;

  font-weight: 400;
  color: #555555;
  line-height: 18px;
}

.exam-value {
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
  line-height: 18px;
}

.exam-detailsContent {
  margin-top: 30px;
  height: 78px;
  border-bottom: 1px solid #bfbfbf;
  padding-bottom: 20px;
  box-sizing: border-box;
}

.studentList-content {
  width: 404px;
  height: 100%;
  border-right: 1px solid #bfbfbf;
}

.classSelector {
  height: 100px;
}

.selector-txt {
  font-size: 24px;

  font-weight: 400;
  color: #000000;
  line-height: 24px;
  margin-right: 30px;
}

.completionStatus {
  font-size: 20px;

  font-weight: 400;
  color: #349afe;
  line-height: 20px;
}

// 查看资源弹窗
.popup-resourceView {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 10;
}

.resourceView-content {
  position: relative;
  width: 520px;
  height: 805px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  padding: 24px 30px;
  box-sizing: border-box;
}

.popup-title {
  font-size: 26px;

  font-weight: 400;
  color: #349afe;
}

.btnClose {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 23px;
  height: 23px;
}

.questionType-block {
  width: 8px;
  height: 18px;
  background: #3096fb;
}

.questionType {
  font-size: 18px;
  font-weight: normal;
  color: #000000;
  margin-left: 12px;
}

.question-score {
  font-size: 18px;
  font-weight: normal;
  color: #1f96fa;
}

.question-txt {
  margin-top: 14px;
  font-size: 18px;
  font-weight: normal;
  color: #1f96fa;
}

.question-stem {
  margin-top: 25px;
  font-size: 18px;
  font-weight: normal;
  color: #777777;
  line-height: 25px;
}

.question-option {
  position: relative;
  margin-top: 16px;
  width: 454px;
  height: 48px;
  background: #1f96fa;
  border: 1px solid #1f96fa;
  border-radius: 10px;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: normal;
  color: #ffffff;
}

.question-option1 {
  position: relative;
  margin-top: 16px;
  width: 454px;
  height: 48px;
  background: #eeeeee;
  border: 1px solid #777777;
  border-radius: 10px;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: normal;
  color: #777777;
}

.answers-box {
  margin-top: 18px;
  width: 454px;
  height: 163px;
  border: 1px solid #777777;
  border-radius: 10px;
  padding: 16px 20px;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: normal;
  color: #777777;
  line-height: 24px;
}

.iconIsItCorrect {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 35px;
  height: 35px;
}

.resourcesDetails-frame {
  margin-top: 28px;
  width: 457px;
  height: 256px;
  background: #ffffff;
  border: 1px solid #757575;
  border-radius: 10px;
}

.resourcesDetails-frame1 {
  width: 457px;
  height: 256px;
  background: #ffffff;
  border: 1px solid #757575;
  border-radius: 10px;
}

.resourcesDetails-typeImg {
  width: 242px;
  height: 243px;
}

.resourcesDetails-detailsList {
  width: 653px;
  height: 280px;
}

.resourcesDetails-img {
  width: 457px;
  height: 256px;
  border-radius: 10px;
}

.resourceView-rolling {
  height: 720px;
  overflow: auto;
}
</style>
